import React, { useState } from 'react';
import { SudokuOrigins } from '../BeginnersGuide/SudokuOrigin/SudokuOrigin';
import { SudokuBasics } from './SudokuBasics/SudokuBasicsController';
import '../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/BeginnersGuideStyle.css';
import { SudokuGameRulesController } from './SudokuGameRules/SudokuGameRulesController';
import { useLanguage } from 'Core/Translations/LanguageContext';

interface BeginnersGuideModalProps {
    onClose: () => void;
}

export const BeginnersGuideModal: React.FC<BeginnersGuideModalProps> = ({ onClose }) => {
    const [activeTab, setActiveTab] = useState<'origins' | 'basics' | 'rules'>('origins');
    const { t } = useLanguage();

    // Handler to close modal only if the overlay itself is clicked.
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-container">
                {/* Separate header container */}
                <div className="modal-header">
                    <div className="modal-title">
                        {t.beginnersGuide.modalTitle}
                        <button className="close-button" onClick={onClose}>
                            &#x00D7;
                        </button>
                    </div>
                </div>

                <div className="modal-content">
                    {/* Tab navigation */}
                    <div className="tab-navigation">
                        <div className="tab-container">
                            <button
                                className={`tab-button ${activeTab === 'origins' ? 'active' : ''}`}
                                onClick={() => setActiveTab('origins')}
                            >
                                {t.beginnersGuide.originsTab}
                            </button>
                            <button
                                className={`tab-button ${activeTab === 'basics' ? 'active' : ''}`}
                                onClick={() => setActiveTab('basics')}
                            >
                                {t.beginnersGuide.basicsTab}
                            </button>
                            <button
                                className={`tab-button ${activeTab === 'rules' ? 'active' : ''}`}
                                onClick={() => setActiveTab('rules')}
                            >
                                {t.beginnersGuide.rulesTab}
                            </button>
                        </div>
                    </div>

                    {/* Tab content */}
                    <div className="tab-content">
                        {activeTab === 'origins' && <SudokuOrigins />}
                        {activeTab === 'basics' && <SudokuBasics onSwitchTab={setActiveTab} />}
                        {activeTab === 'rules' && <SudokuGameRulesController onClose={onClose} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BeginnersGuideModal;